/********************************************************************************
 * Copyright (c) 2021, 2023 BMW Group AG
 * Copyright (c) 2021, 2023 Contributors to the Eclipse Foundation
 *
 * See the NOTICE file(s) distributed with this work for additional
 * information regarding copyright ownership.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Apache License, Version 2.0 which is available at
 * https://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
 * License for the specific language governing permissions and limitations
 * under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 ********************************************************************************/

import React from 'react'
import { IInputProps } from './DropzoneTypes'
import { DropArea } from '../components/DropArea'

class Input extends React.PureComponent<IInputProps> {
  render() {
    const {
      inputClassName,
      style,
      accept,
      inputContentTitle,
      inputContentSubTitle,
      multiple,
      disabled,
      getFilesFromEvent,
      onFiles,
      size,
    } = this.props

    return (
      <DropArea
        disabled={disabled}
        translations={{
          title: inputContentTitle,
          subTitle: inputContentSubTitle,
          errorTitle: '',
        }}
        size={size}
      >
        <input
          className={inputClassName}
          style={style}
          type="file"
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          onChange={async (e) => {
            const target = e.target
            const chosenFiles = await getFilesFromEvent(e)
            onFiles(chosenFiles)
            target.value = ''
          }}
        />
      </DropArea>
    )
  }
}
export default Input
